"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.choice_present = exports.present = void 0;
function present(exp) {
    switch (exp.kind) {
        case "Exp.v": {
            return exp.name;
        }
        case "Exp.fn": {
            return { $fn: [exp.name, present(exp.ret)] };
        }
        case "Exp.ap": {
            return { $ap: [present(exp.target), ...exp.args.map(present)] };
        }
        case "Exp.str": {
            return JSON.stringify(exp.value);
        }
        case "Exp.pattern": {
            return exp.value.flags
                ? { $pattern: [exp.label, exp.value.source, exp.value.flags] }
                : { $pattern: [exp.label, exp.value.source] };
        }
        case "Exp.grammar":
            const choices = {};
            for (const [choice_name, parts] of exp.choices) {
                Object.assign(choices, choice_present(exp.name, choice_name, parts));
            }
            return { $grammar: choices };
    }
}
exports.present = present;
function choice_present(grammar_name, choice_name, parts) {
    return {
        [`${grammar_name}:${choice_name}`]: parts.map((part) => {
            const { name, value } = part;
            return name ? { [name]: present(value) } : present(value);
        }),
    };
}
exports.choice_present = choice_present;
//# sourceMappingURL=exp-present.js.map